import React from 'react';
import VideoEmbed from 'components/VideoEmbed';

// A component to embed youtube videos that are linked to.
// Written based on react-linkify.
// Must be ABOVE Linkify in the heirarchy, or Linkify will wrap links before
//   Youtubify can convert them to embeds.

// Regex for identifying youtube links in text and capturing the videoId
// From https://stackoverflow.com/a/5831191 (with pre-linked lookahead removed)
const YOUTUBE_REGEX =
  /https:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*?[^\w\s-])([\w-]{11})(?=[^\w-]|$)[?=&+%\w.-]*/gi;

function parseString(string) {
  const parts = string.split(YOUTUBE_REGEX);
  const elements = [];
  let p = 0;
  while (p < parts.length) {
    elements.push(parts[p]);
    p += 1;
    if (p < parts.length) {
      elements.push(<VideoEmbed key={'yt' + p} videoId={parts[p]} />);
      p += 1;
    }
  }
  return elements.length === 1 ? elements[0] : elements;
}

function parse(children, key = 0) {
  if (typeof children === 'string') {
    return parseString(children);
  } else if (
    React.isValidElement(children) &&
    children.type !== 'a' &&
    children.type !== 'button'
  ) {
    return React.cloneElement(
      children,
      { key: key },
      parse(children.props.children)
    );
  } else if (Array.isArray(children)) {
    return children.map((child, i) => parse(child, i));
  }

  return children;
}

export default function Youtubify({ children }) {
  return [parse(children)];
}
